import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const planningService = {
  getAllPlannings,
  getPlanningById,
  deletePlanning,
  updatePlanning,
  createPlanning,
  requestPlanning,
  getAllUsersPlannings,
  getFramePanelsByPlanningId,
  duplicatePlanning,
  getSearchHistory,
  getFramePanelsByHistoryId,
  deleteSearchRecord,
  planningSearchOrFilter,
  savePlanningSystems,
  changeState,
  getPlanningsByCampaignId,
  getPanelSuggestions,
  getPanelsSuggestionsNoPagination,
  assignPlanner,
  assignNegotiation,
  getAllUserPlanners,
  getAllPlanningsStats,
  getAllAdvertisersNoPagination
};

const { apiUrl, apiVer } = defineConfig.PLANNING_SERVICE;

function getApiPath() {
  return (apiUrl + apiVer + "/planning");
}

function getFramePanelApiPath() {
  return (apiUrl + "v3" + "/planning/framePanel");
}

function getSearchApiPath() {
  return (apiUrl + apiVer + "/planning/search");
}

function getSearchHistory(id) {
  const url = getSearchApiPath() + `/all/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deleteSearchRecord(id) {
  const url = getSearchApiPath() + `/delete/` + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function planningSearchOrFilter(planningObj = {}) {
  const url = getSearchApiPath() + `/create`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(planningObj),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getPanelSuggestions(searchTerm, searchField, page = 0, size = 20, sortBy = "createdAt", sortDir = "desc", type = "ALL", planningId, filters = {}) {
  const url = getSearchApiPath() + `/all/suggestion?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}&type=${type}&planningId=${planningId}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getPanelsSuggestionsNoPagination(searchTerm, searchField, type = "ALL", planningId, filters = {}) {
  const url = getSearchApiPath() + `/all/suggestion/map?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&type=${type}&planningId=${planningId}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getFramePanelsByHistoryId(id) {
  const url = getSearchApiPath() + `/all/history/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getFramePanelsByPlanningId(id) {
  const url = getFramePanelApiPath() + `/all/planning/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllPlannings(page, pageSize = 10, filters = {}, sorter = {}) {
  let queryParams = [];
  let sortType = sorter.order === 'descend' ? 'desc' : 'asc';
  let sortValue = sorter.field || "creationDate"

  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = apiUrl + "v3/planning" + "/all/" + page + "/" + pageSize + "/" + sortValue + "/" + sortType + queryString;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getPlanningById(id) {
  const url = apiUrl + `v3/planning/read/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deletePlanning(id) {
  const url = apiUrl + `v3/planning/delete/` + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updatePlanning(id, body) {
  const url = apiUrl + `v3/planning/update/` + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function createPlanning(body) {
  const url = apiUrl + `v3/planning/create`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function requestPlanning(campaign, plannerEmail) {
  const url = apiUrl + `v3/planning/create/request`;

  const formattedBody = {
    ...campaign,
    plannerEmail,
  };

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(formattedBody),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllUsersPlannings() {
  const url = getApiPath() + "/all/user";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function duplicatePlanning(planningId, values) {
  const url = apiUrl + `v3/planning/create/duplicate/` + planningId;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(values),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function savePlanningSystems(planningId, frameIds) {
  const url = apiUrl + "v3/planning/update/" + planningId + "/system";

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameIds),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function changeState(id) {
  const url = getApiPath() + "/update/" + id + "/state";

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getPlanningsByCampaignId(campaignId) {
  const url = getApiPath() + `/all/campaign/` + campaignId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function assignPlanner(planningId) {
  const url = apiUrl + `v3/planning/update/planner/` + planningId;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function assignNegotiation(planningId, campaignId) {
  const url = apiUrl + `v3/planning/update/` + planningId + "/" + campaignId;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllUserPlanners() {
  const url = apiUrl + "v3/planning/all/planner";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllPlanningsStats() {
  const url = apiUrl + "v3/planning/all/statistic";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllAdvertisersNoPagination() {
  const url = apiUrl + "v3/planning/all/advertiser";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}